var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.076,
    viewBox: "0 0 16 9.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-caret-down",
    "data-name": "Icon awesome-caret-down",
    d: "M1.871,13.5H15.718a1.074,1.074,0,0,1,.759,1.835L9.556,22.261a1.078,1.078,0,0,1-1.523,0L1.112,15.335A1.074,1.074,0,0,1,1.871,13.5Z",
    transform: "translate(16.794 22.576) rotate(180)",
    fill: "#6ab271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitArrow);
export default __webpack_public_path__ + "static/media/profit_arrow.b26dfd14f16a516edc14d5f551267284.svg";
export { ForwardRef as ReactComponent };